module.exports = __webpack_public_path__ + "static/media/android5.e9b454d9.jpg";